import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    showClosestStoreMarker: false,
    mapContentCollapsed: false,
    modal: {
        isVisible: false,
        component: null,
        params: {},
    },
};
export const uiSlice = createSlice({
    name: 'ui',
    initialState,
    selectors: {
        getShowClosestStoreMarker: state => {
            return state.showClosestStoreMarker;
        },
        getMapContentCollapsed: state => {
            return state.mapContentCollapsed;
        },
    },
    reducers: {
        showClosestStoreMarker: state => {
            state.showClosestStoreMarker = true;
        },
        hideClosestStoreMarker: state => {
            state.showClosestStoreMarker = false;
        },
        openMapContent: state => {
            state.mapContentCollapsed = false;
        },
        closeMapContent: state => {
            state.mapContentCollapsed = true;
        },
        openModal: (state, action) => {
            state.modal.isVisible = true;
            state.modal.component = action.payload.component;
            if (action.payload.params) {
                state.modal.params = action.payload.params;
            }
        },
        resetModal: state => {
            state.modal.isVisible = false;
            state.modal.component = null;
            state.modal.params = {};
        },
    },
});
export const { getShowClosestStoreMarker, getMapContentCollapsed } = uiSlice.selectors;
export const { showClosestStoreMarker, hideClosestStoreMarker, openMapContent, closeMapContent, openModal, resetModal, } = uiSlice.actions;
